/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useState, useEffect } from "react";
import { Tab } from "@mui/material";
import { isEmpty } from "lodash";
import { isArrayNotEmpty } from "utils/empty-exists";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { TabContentDisplay } from "./tab-content";

const TabGroupComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const { tabs } = component || {};
    const firstTabGuid = isArrayNotEmpty(tabs) ? tabs[0]?.guid : undefined;
    const hasContent = !isEmpty(tabs) || !isEmpty(tabs);
    const [selectedTab, setSelectedTab] = useState(firstTabGuid);
    const [currentTab, setCurrentTab] = useState();
    const selectTab = (event, guid) => {
        setSelectedTab(guid);
        if (isArrayNotEmpty(tabs)) {
            const tab = tabs.find((tab) => tab.guid === guid);
            setCurrentTab(tab);
        }
    };
    useEffect(() => {
        selectTab(null, firstTabGuid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firstTabGuid]);
    
    return (
        <>
            {!hasContent &&
                <EmptyContentMessage
                    hasContent={hasContent}
                    component={component}
                />
            }
            {hasContent &&
                <>
                    {/* This renders the actual tab content */}
                    {/*<div style={styles.tabContents}>*/}
                    <div>
                        {isArrayNotEmpty(tabs) && tabs.map((tab, index) => {
                            const { guid } = tab || {};
                            const key = index + guid;
                            return (
                                <Tab
                                    onClick={(event) => selectTab(event, guid)}
                                    key={key}
                                    value={guid}
                                    label={tab.title}
                                // icon={getIcon(tab)}
                                // iconPosition={'start'}
                                // className={getClasses(tab)}
                                />
                            );
                        })}
                        <TabContentDisplay
                            key={selectedTab}
                            guid={selectedTab}
                            tabs={tabs}
                            tab={currentTab}
                        />
                        
                        {/*{isArrayNotEmpty(tabs) && tabs.map((tab, index) => {*/}
                        {/*    const {guid} = tab || {}*/}
                        {/*    return <>*/}
                        {/*        <TabContentDisplay*/}
                        {/*            key={guid}*/}
                        {/*            guid={guid}*/}
                        {/*            tabs={tabs}*/}
                        {/*            tab={tab}*/}
                        {/*        />*/}
                        {/*    </>*/}
                        {/*})}*/}
                    </div>
                </>
            }
        </>
    );
};

TabGroupComponentDisplay.displayName = "TabGroupComponentDisplay";
export { TabGroupComponentDisplay };
